import { createSelector } from '@reduxjs/toolkit'
import { useT } from '@transifex/react'
import { useMemo } from 'react'
import { useAppSelector } from '../../../../state/hooks'
import {
  isCompleted,
  isReturn,
  saleIsExchange,
} from '../../../../functions/sale'
import { RootState } from '../../../../state/store'
import {
  selectLineItems,
  selectOutstandingBalance,
  selectSaleFinals,
  selectSalePayments,
  selectSaleStatus,
} from '../../../../state/slices/currentSale/currentSaleSlice'

const dataSelector = createSelector(
  [
    (state: RootState) => state.currentSale.returnFor,
    (state: RootState) => selectLineItems(state),
    (state: RootState) => selectSaleStatus(state),
    (state: RootState) => selectSaleFinals(state),
    (state: RootState) => selectSalePayments(state),
    (state: RootState) => state.currentSale.payAccountBalance,
  ],
  (returnFor, lineItems, status, finals, payments, payAccountBalance) => ({
    returnFor,
    lineItems,
    status,
  })
)

export const usePaymentHeading = () => {
  const t = useT()
  const saleData = useAppSelector(dataSelector)
  const currentBalance = useAppSelector(selectOutstandingBalance)

  const heading = useMemo(() => {
    if (!isReturn(saleData) && !saleIsExchange(saleData)) {
      if (!isCompleted(saleData.status)) {
        return t('Pay')
      } else {
        return t('Payment')
      }
    }
    if (saleIsExchange(saleData)) {
      if (currentBalance > 0) {
        return t('Exchange and pay')
      }
      if (currentBalance < 0) {
        return t('Exchange and refund')
      }
      return t('Exchange')
    }
    return t('Refund')
  }, [currentBalance, saleData, t])

  return heading
}
